import type { PaymentMethod } from '@repo/domain';
import { BusinessValidationCode, BusinessValidationError, NetworkError } from '@repo/domain-service';
import type { NavigateFunction } from 'react-router-dom';

import { trackReservationFailure } from '@features/reservation/trackers/trackReservationResponse';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export function handleReservationError(
  error: unknown,
  navigate: NavigateFunction,
  paymentMethod: PaymentMethod | undefined
): void {
  if (error instanceof NetworkError) throw error;
  trackReservationFailure({ paymentMethod, error });
  if (error instanceof BusinessValidationError && error.code === BusinessValidationCode.activeReservationExists) {
    navigate(ROUTE_PATHS[RouteName.ACCOUNT_RESERVATIONS]);
    return;
  }
  navigate(ROUTE_PATHS[RouteName.RESERVATION_FAILURE]);
}
